import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7451ba36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "user-profile--public-info" }
const _hoisted_3 = {
  key: 0,
  class: "user-profile__username highlighted-text"
}
const _hoisted_4 = {
  key: 1,
  class: "user-profile__username highlighted-text"
}
const _hoisted_5 = {
  key: 2,
  class: "user-profile__biography"
}
const _hoisted_6 = {
  key: 3,
  class: "user-profile__biography"
}
const _hoisted_7 = { class: "action-buttons" }
const _hoisted_8 = { class: "user-profile--private-info" }
const _hoisted_9 = { class: "user-profile__personal-info" }
const _hoisted_10 = { class: "b-user-profile__personal-info b" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "personal-info__title" }, "Informações pessoais:", -1))
const _hoisted_12 = { class: "personal-info__list list" }
const _hoisted_13 = { class: "personal-info__item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "personal-info__label" }, "CPF:", -1))
const _hoisted_15 = {
  key: 0,
  class: "personal-info__text highlighted-text"
}
const _hoisted_16 = {
  key: 1,
  class: "personal-info__text highlighted-text"
}
const _hoisted_17 = { class: "personal-info__item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "personal-info__label" }, "Data de nascimento:", -1))
const _hoisted_19 = {
  key: 0,
  class: "personal-info__text highlighted-text"
}
const _hoisted_20 = {
  key: 1,
  class: "personal-info__text highlighted-text"
}
const _hoisted_21 = { class: "personal-info__item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "personal-info__label" }, "E-mail:", -1))
const _hoisted_23 = { class: "personal-info__text highlighted-text" }
const _hoisted_24 = { class: "user-profile__interests" }
const _hoisted_25 = { class: "b-user-profile__interests b" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "interests__title" }, "Seus interesses:", -1))
const _hoisted_27 = {
  key: 0,
  class: "interests__list list"
}
const _hoisted_28 = { class: "highlighted-text-interest" }
const _hoisted_29 = {
  key: 1,
  class: "interests__list"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Nenhum ", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "user-profile__activity"
}
const _hoisted_33 = { class: "b" }
const _hoisted_34 = {
  key: 0,
  class: "activity__title"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Seus decoins: ")
const _hoisted_36 = { class: "highlighted-text bold" }
const _hoisted_37 = { class: "activity__list list" }
const _hoisted_38 = {
  key: 0,
  class: "link"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "highlighted-text" }, "Visualizar extrato", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonPhoto = _resolveComponent("PersonPhoto")!
  const _component_Suggestion = _resolveComponent("Suggestion")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PersonPhoto, {
        class: "user-profile__pic",
        image: $setup.noCacheImage,
        name: $props.user.name || 'usuário',
        height: "80px",
        width: "80px"
      }, null, 8, ["image", "name"]),
      ($props.user.name)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString($setup.capitalizeUserName($props.user.name)), 1))
        : (_openBlock(), _createElementBlock("h2", _hoisted_4, " Usuário sem nome ")),
      ($props.user.biography)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.user.biography), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, " Você ainda não possui uma biografia. ")),
      _createElementVNode("div", _hoisted_7, [
        ($setup.showButtonBoarding())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn--boarding",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.redoOnBoarding && $setup.redoOnBoarding(...args)))
            }, " Refazer onboarding "))
          : _createCommentVNode("", true),
        ($setup.configuration.isSuggestionMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn--boarding",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openSuggestion()))
            }, " Dê sua sugestão "))
          : _createCommentVNode("", true),
        _createVNode(_component_Suggestion, {
          isOpen: $setup.showConfirmation,
          onToggle: $setup.closeSuggestionModal
        }, null, 8, ["isOpen", "onToggle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("ul", _hoisted_12, [
            _createElementVNode("li", _hoisted_13, [
              _hoisted_14,
              ($props.user.document)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($options.maskCPF($props.user.document)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($options.maskCPF("00000000000")), 1))
            ]),
            _createElementVNode("li", _hoisted_17, [
              _hoisted_18,
              ($props.user.birthDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($options.formatBirthDate($props.user.birthDate)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, " --/--/---- "))
            ]),
            _createElementVNode("li", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, _toDisplayString($props.user.email), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          ($props.interests.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.interests, (interest, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(interest.title), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
        ])
      ]),
      ($options.isDecolaTemplate())
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              ($setup.hasCompany)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString($setup.toDecoins($props.user.decoins)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_37, [
                ($setup.hasCompany)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                      _createVNode(_component_router_link, { to: { name: 'statement' } }, {
                        default: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}